import React from 'react'
import { Button, QRCode } from 'antd'
import WebMain from './WebMain'
function Service() {
    return (
        <WebMain selectedKeys='contact'>            
            <div
                style={{
                    
                    backgroundColor:"#ddd",
                    display:'flex',
                    justifyContent:'center',
                    height:'100vh',
                    padding:'20px',
                    
                }}
            >
                <div
                    style={{
                        width:'100%',
                        maxWidth:'500px',
                        maxHeight:'300px',
                        backgroundColor:'#fff',
                        borderRadius:'10px',
                        padding:'40px',
                        boxShadow:'0 2px 10px rgba(0,0,0,0.1)',
                    }}
                >
                    <div>电脑登录微信，请点击 <Button type='primary' style={{marginLeft:'40px'}} onClick={() => {window.open('https://work.weixin.qq.com/ca/cawcde64d15ad70e2f')}}>微信客服</Button></div>
                    <div style={{display:'flex',alignItems:'center',marginTop:'30px'}}>
                        <div>手机扫码，添加微信</div>
                        <div style={{marginLeft:'40px'}}>
                            <QRCode value='https://work.weixin.qq.com/ca/cawcde64d15ad70e2f' size={140} />
                        </div>
                    </div>
                </div>
            </div>
        </WebMain>
    )
}

export default Service